export default {
    locales: ['en'],
    messages: {
        'place': 'Overall',
        'place-mobile': 'Overall : {rank}',
        'bib': 'Bib',
        'name': 'Name',
        'hometown': 'Hometown',
        'bracket': 'Bracket Rank',
        'bracket2': 'Bracket',
        'rank': 'Rank',
        'pace': 'Pace',
        'chip': 'Chip',
        'time': 'Time',
        'time-mobile': 'Time : {time}',
        'generated_at': 'Generated {time}',
        'loading': 'Loading',
        'data-load-error': 'Looks like there was a problem loading Data.',
        'waiting-results': 'Waiting for results',
        'error': 'Error',
        'gender': 'Gender'
    }
};



// WEBPACK FOOTER //
// ./translate/en.js